var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{key:_vm.value,staticClass:"safe-phone notranslate",staticStyle:{"font":"inherit","font-weight":"inherit","color":"inherit"},attrs:{"data-sl-dialer":"off","data-rc-call-ignore":"true","data-no-dialer":"true"}},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }